export default "__VITE_ASSET__c62ba138__"